module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['content', {
      'zh-style': _vm.language === 'zh'
    }]
  }, [(_vm.records.length === 0 && !_vm.loading) ? _c('empty-reminder') : _vm._e(), _vm._v(" "), (_vm.records.length > 0) ? _c('div', {
    attrs: {
      "id": "pc-records"
    }
  }, [_c('div', {
    staticClass: "little-title"
  }, [_c('p', {
    staticClass: "description"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('description')))])]), _vm._v(" "), _c('p', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.$t('type')))]), _vm._v(" "), _c('p', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.$t('amount')))]), _vm._v(" "), _c('p', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.$t('status')))])]), _vm._v(" "), _vm._l((_vm.records), function(record) {
    return _c('div', {
      staticClass: "records"
    }, [_c('p', {
      staticClass: "description"
    }, [_vm._v("\n        " + _vm._s(_vm.$t('yourFriends')) + " " + _vm._s(record.nickname) + " " + _vm._s(_vm.$t('bought')) + "\n        " + _vm._s(record.package_device_count) + " " + _vm._s(_vm.$tc('devices', record.package_device_count)) + "\n        " + _vm._s(_vm.$t(record.package_name)) + _vm._s(_vm.$t('plan')) + "\n        "), (record.status === 'cancelled') ? [_vm._v(_vm._s(_vm.$t('refunded')))] : _vm._e()], 2), _vm._v(" "), _c('p', {
      staticClass: "type"
    }, [_vm._v(_vm._s(record.first_purchase ? _vm.$t('firstTopup') : _vm.$t('renew')))]), _vm._v(" "), _c('p', {
      class: ['amount', {
        'on-hold': _vm.awardOnHold(record.status)
      }]
    }, [_vm._v(_vm._s(_vm.$t(_vm.currentSymbol)) + " " + _vm._s(record[_vm.currentSymbol]))]), _vm._v(" "), _c('p', {
      class: ['status', {
        'on-hold': _vm.awardOnHold(record.status)
      }]
    }, [_vm._v(_vm._s(_vm.$t(record.status)))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pager-bar"
    }
  }, [_c('div', {
    staticClass: "spinner-component-box"
  }, [_c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1), _vm._v(" "), _c('pager', {
    attrs: {
      "total-page": _vm.totalPage,
      "init-page": _vm.currentPage
    },
    on: {
      "go-page": _vm.getAwardRecords
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0348904c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commission/rewardRecords/RewardRecordsPc.vue
// module id = 1254
// module chunks = 1